import { ValidationSummary } from 'devextreme-react/validation-summary';
import { Box, Item } from 'devextreme-react/box';
import Toolbar, { Item as ToolbarItem } from 'devextreme-react/toolbar';
import {
	ActualMeasureDatesPanel,
	ActualMeasureFiles,
	ActualMeasureFilesButton,
	CreateEstimateButton,
	ExitButton,
	RequestCancellationButton,
	RetailOrderAddNoteButton,
	RetailOrderCommunicationButton,
	RetailOrderInformationCards,
	RetailOrderNotesPanel,
	RetailOrderPage,
	RetailOrderProducts,
	RetailOrderProgress,
	RetailOrderProgressStep,
	SaveButton,
	SetToPendingButton,
	WorksheetTemplateLink,
	WorksheetType
} from '../../../features/cfi/retail-order';
import '../../../css/order.scss';

export default function RetailOrderActualMeasurePage() {

	return (
		<RetailOrderPage>

			<RetailOrderInformationCards />

			<RetailOrderProgress />

			<ValidationSummary />

			<Box>
				<Item ratio={1}>
					<Toolbar className='button-toolbar' multiline={true}>
						<ToolbarItem>
							<SaveButton step={RetailOrderProgressStep.Measure} />
						</ToolbarItem>
						<ToolbarItem>
							<RetailOrderCommunicationButton />
						</ToolbarItem>
						<ToolbarItem>
							<ActualMeasureFilesButton />
						</ToolbarItem>
						<ToolbarItem>
							<SetToPendingButton />
						</ToolbarItem>
						<ToolbarItem>
							<CreateEstimateButton />
						</ToolbarItem>
						<ToolbarItem>
							<RequestCancellationButton />
						</ToolbarItem>
						<ToolbarItem>
							<ExitButton />
						</ToolbarItem>
					</Toolbar>
				</Item>
				<Item ratio={0} baseSize={190}>
					<Toolbar className='button-toolbar' multiline={true}>
						<ToolbarItem>
							<RetailOrderAddNoteButton showNoteType={false} changeOrder={false} />
						</ToolbarItem>
					</Toolbar>
				</Item>
			</Box>

			<Box>
				<Item ratio={1}>
					<ActualMeasureDatesPanel />
				</Item>
				<Item ratio={1}>
					<RetailOrderNotesPanel height={200} />
				</Item>
			</Box>

			<WorksheetTemplateLink
				worksheetType={WorksheetType.CabinetMeasure}
				caption="Download Cabinet Measure Worksheet Template"
			/>

			<ActualMeasureFiles />

			<RetailOrderProducts />

		</RetailOrderPage>
	)
}
